module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-12.66e1a965.png";